import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocationBadgeComponent } from './location-badge.component';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { StationsServiceModule } from 'shared/stations-service/stations.module';
import { RoutedDialogWrapperModule } from 'shared/routed-dialog/routed-dialog.module';
import { DatePipeModule } from 'shared/pipes/date/date-pipe.module';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CustomerPrivacyModule } from 'layout/customer-privacy/customer-privacy.module';

@NgModule({
    declarations: [LocationBadgeComponent],
    imports: [
        CommonModule,
        MatIconModule,
        RouterModule,
        StationsServiceModule,
        RoutedDialogWrapperModule,
        DatePipeModule,
        MatTooltipModule,
        CustomerPrivacyModule,
    ],
    exports: [LocationBadgeComponent],
})
export class LocationBadgeModule {}
